import { render, staticRenderFns } from "./_preAddMatch.vue?vue&type=template&id=312607d4&scoped=true&lang=pug&"
import script from "./_preAddMatch.vue?vue&type=script&lang=js&"
export * from "./_preAddMatch.vue?vue&type=script&lang=js&"
import style0 from "./_preAddMatch.vue?vue&type=style&index=0&id=312607d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312607d4",
  null
  
)

export default component.exports